import * as React from 'react';
import { useMemo, useState } from 'react';

import { Button } from '@rmwc/button';
import '@rmwc/button/styles';

import { TrackerData, SelectableStateType } from '../types';
import { getTrackerState, getTrackerArrayState } from '../state_calc';
import { ImportButton } from './import_button';
import { TrackerList } from './tracker_list';
import { FilterInput } from './filter_input';
import { TrackerStateChoice } from './tracker_state_choice';
import { TrackerMap } from './tracker_map';
import { useUiState } from './ui_state';
import { useSite } from './backend';
import { UploadsButton } from './uploads_button';
import { ExportButton } from './export_button';
import { SiteHeader } from './site_header';
import { ResetKeyButton } from './reset_key_button';
import { useClientSetting } from '../client_settings';
import { useSearchFilter, useSortTrackers, useStateFilter } from '../util';

export interface SiteViewProps {
  id: string;
}

export const SiteView: React.FC<SiteViewProps> = ({ id }) => {
  const siteQuery = useSite(id);
  const showMap = useClientSetting('showMap');

  const [filter, setFilter] = useState<string>('');
  const [state, setState] = useState<SelectableStateType>('all');

  const uiState = useUiState();

  const site = siteQuery.data;
  const entries = useSortTrackers(site?.trackers);
  const searchFiltered = useSearchFilter(entries, filter);
  const stateFiltered = useStateFilter(searchFiltered, state);

  const filteredTrackers = stateFiltered;

  let map;

  if(showMap) {
    map = (
      <div className="map">
        <TrackerMap trackers={searchFiltered} uiState={uiState} comms={site?.communication} colorMode={'normal'} />
      </div>
    );
  }

  return <div className="site">
    <div className="header">
      <SiteHeader hasMap site={site} />
      <div className="filter_bar">
        <TrackerStateChoice value={state} update={setState} trackers={searchFiltered} />
        <FilterInput value={filter} update={setFilter} />
      </div>
    </div>
    <div className="content">
      <div className="list">
        <TrackerList siteId={site?.id} trackers={filteredTrackers} empty={entries?.length == 0} uiState={uiState} />
        <div className="button_bar">
          <ImportButton site={site} />
          <UploadsButton id={id} site={site} />
          <ExportButton site={site} />
          <ResetKeyButton site={site} />
        </div>
      </div>
      {map}
    </div>
  </div>;
}
